<template>
    <el-dialog title="设置服务类目" :visible.sync="dialogVisible" @close="dialogFormVisible" 
    :close-on-press-escape="false">
    <div class="table-wrap">
        <el-table size="small" :data="tableData" height="440" border style="width: 100%" v-loading="loading">
          <el-table-column prop="first_class" label="一级类目" ></el-table-column>
          <el-table-column prop="second_class" label="二级类目"></el-table-column>

        </el-table>
      </div>


  





    <el-button style="float: right;margin-top: 10px;" @click="jump"  type="primary">前往设置</el-button>
    <div style="clear:both;"></div>
     

    </el-dialog>
  </template>
  
  <script>
  import PortApi from '@/api/port.js';
  export default {
    data() {
      return {
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        /*是否显示*/
        dialogVisible: false,
        tableData:[],

      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      loading:true,
      };
    },
    props: ['tip'],
    watch: {
        tip: function(n, o) {
        if (n != o) {
          this.dialogVisible = this.tip;
          this.port_id = this.$route.query.port_id;
          this.getData(this.port_id)
        }
      }
    },
    created() {
       
     
    },
    methods: {
        getData(port_id) {
      var form = this.form;
      let self = this;
      let Params = {};
      Params.port_id = port_id;
      console.log(Params)
      PortApi.getcategory(Params, true)
        .then(res => {
          self.loading = false;
          if(res.msg == "success"){
            self.tableData = res.data.category_list
          }
        
        })
        .catch(error => {self.loading = false;});
    },
      /*选择第几页*/
      handleCurrentChange(val) {
      this.curPage = val;
      this.getData(this.port_id);
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData(this.port_id);
    },
        jump(){
            window.open("https://mp.weixin.qq.com/")
        },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('close', {
            type: 'success',
            openDialog: false
          });
        } else {
          this.$emit('close', {
            type: 'error',
            openDialog: false
          });
        }
      }
    }
  };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/views/plus/port/manager/codemanager/dialog/tip.vue